import { createContext, useContext } from 'react';

export type DE2TrackingContextValue = {
  studyId: number;
  useSuggestions: boolean;
  featuresLoading: boolean;
};

export const DE2TrackingContext = createContext<DE2TrackingContextValue | null>(
  null
);

export const useDE2TrackingContext = () => useContext(DE2TrackingContext);
